import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_subject_card_header = _resolveComponent("subject-card-header")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_topic_item = _resolveComponent("topic-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_spinner_orbit = _resolveComponent("q-spinner-orbit")!
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")!

  return (_openBlock(), _createBlock(_component_q_card, {
    class: "relative-position",
    "data-cy": `subject-card${_ctx.index}`
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card_section, { class: "expansion-subject no-padding" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_expansion_item, {
            "expand-separator": "",
            style: {"border-radius":"inherit"},
            "data-cy": "expand-material",
            modelValue: _ctx.opened,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.opened) = $event)),
            "header-class": ["q-pa-md"],
            onBeforeShow: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showContent = true)),
            onAfterHide: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showContent = false)),
            "expand-icon-class": "hidden"
          }, {
            header: _withCtx(() => [
              _createVNode(_component_subject_card_header, {
                tree: _ctx.tree,
                expanded: _ctx.opened
              }, null, 8, ["tree", "expanded"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_q_separator),
              _createVNode(_component_q_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_card_section, { class: "no-padding" }, {
                    default: _withCtx(() => [
                      (_ctx.showContent)
                        ? (_openBlock(), _createBlock(_component_q_list, {
                            key: 0,
                            separator: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tree.topics, (topic, t) => {
                                return (_openBlock(), _createBlock(_component_topic_item, {
                                  topic: topic,
                                  subject: _ctx.tree.subject,
                                  "data-cy": "expand-topic"
                                }, null, 8, ["topic", "subject"]))
                              }), 256))
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.showPracticeBtn)
                ? (_openBlock(), _createBlock(_component_q_separator, { key: 0 }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      (_ctx.showPracticeBtn)
        ? (_openBlock(), _createBlock(_component_q_card_section, {
            key: 0,
            class: "q-gutter-x-md"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                push: "",
                label: "Estudar",
                "data-cy": "study-material",
                color: "positive",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.expandCard()))
              }),
              _createVNode(_component_q_btn, {
                push: "",
                label: "Praticar",
                "data-cy": "pratice-material",
                color: "primary",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push(`/objetivas/${_ctx.tree.subject}`)))
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_q_inner_loading, {
        showing: _ctx.loading,
        style: {"z-index":"1"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_spinner_orbit, {
            size: "4em",
            color: "white",
            thickness: 2
          })
        ]),
        _: 1
      }, 8, ["showing"])
    ]),
    _: 1
  }, 8, ["data-cy"]))
}